import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';

const FeaturesPage = () => {
  const navigate = useNavigate();

  const memberFeatures = [
    { title: 'Multi-step Application', desc: 'Save & resume via unique link — complete at your own pace' },
    { title: 'Property Discovery', desc: 'Browse, filter & sort all active properties by suburb, state, rent & bedrooms' },
    { title: 'Recommended Properties', desc: 'Properties matched to your preferred suburbs/states & budget' },
    { title: 'Save & Shortlist', desc: 'Shortlist properties and members for easy comparison' },
    { title: 'Suburb Alerts', desc: 'Up to 3 suburb alerts — get notified when new matching listings appear' },
    { title: 'People & Groups', desc: 'Browse member profiles, join property groups, form housemate groups' },
    { title: 'Direct Messaging', desc: 'Member-to-member private messaging with notification alerts' },
    { title: 'Community Chat', desc: 'Open community chat room for all members' },
    { title: 'Forum', desc: 'Discussion threads on shared living, tips, and experiences' },
    { title: 'Rental Bond Loan Gateway', desc: 'Access state-specific Government bond loan programmes — no commercial lenders needed' },
    { title: 'Profile Management', desc: 'Edit preferences, budget, suburbs, notification settings' },
    { title: 'Membership Payment', desc: 'Secure Stripe payment — 6-month Single ($190) or Couple ($290). Gold Envoy $20 for first 100 applications.' },
  ];

  const publicFeatures = [
    { title: 'Public Property Browse', desc: 'All active listings visible without login — sort, filter, paginate' },
    { title: 'Landing Page Carousel', desc: 'Live property carousel with photos, rent, and CRA net-rent figures' },
    { title: 'Available Now Panel', desc: 'Live count of properties + average rents, pension % comparisons' },
    { title: 'The HSS Difference', desc: 'Side-by-side comparison of private renting vs HSS Group Tenancy' },
    { title: 'How It Works', desc: '4-step overview of the application, vetting, approval and matching process' },
    { title: 'Member Fees', desc: 'Transparent fee schedule — no hidden charges, no per-group fees' },
    { title: 'CRA Rent Assistance Calculator', desc: 'Live Centrelink CRA calculations showing net rent for singles & couples' },
    { title: 'Rent Calculator Tables', desc: 'Detailed rent tables showing net rent after CRA across all rent bands' },
    { title: 'REA Information Pack', desc: 'Downloadable info pack for Real Estate Agents and property owners' },
    { title: 'FAQ', desc: 'Comprehensive answers to common questions about HSS membership and shared living' },
    { title: 'Contact Directory', desc: 'Role-specific email addresses for members, REAs, media, and government' },
    { title: 'Resources & Downloads', desc: 'Guides, templates, and tools for shared housing planning' },
    { title: 'House Policies', desc: '11 downloadable house policy templates for HSS shared households' },
    { title: 'Live Chat', desc: 'Tawk.to live chat support during business hours' },
  ];

  const adminFeatures = [
    { title: 'Application Review', desc: 'Full application detail view, approve/reject, admin notes, CSV export' },
    { title: 'Member Management', desc: 'View/edit/suspend members, fee waivers, housed status, CSV export' },
    { title: 'Property Management', desc: 'Full CRUD, inline editing, Cloudinary images, auto-expiry, duplicate detection' },
    { title: 'CSV & Email Import', desc: 'Bulk CSV upload + automatic POP3 email import from Domain.com.au alerts' },
    { title: 'Group Management', desc: 'View/move members between groups, delete groups, support requests queue' },
    { title: 'Announcements', desc: 'Broadcast messages to all members via in-app + email' },
    { title: 'Analytics Dashboard', desc: 'Applications, members, properties, and enquiry metrics' },
    { title: 'Data Quality Tools', desc: 'Postcode backfill, suburb fixer, junk address archiver, zero-rent checker' },
    { title: 'System Health Checks', desc: 'POP3 status, email quota, stuck applications, orphan groups (runs every 6h)' },
  ];

  const Section = ({ title, items, color }) => (
    <div className="content-section">
      <h2 style={{ color }}>{title}</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '10px', marginTop: '16px' }}>
        {items.map((item, i) => (
          <div key={item.title} style={{ padding: '12px 16px', background: '#f8fafb', borderRadius: '8px', borderLeft: `3px solid ${color}` }}>
            <div style={{ fontWeight: '700', fontSize: '15px', color: '#1a2332', marginBottom: '4px' }}>{item.title}</div>
            <div style={{ fontSize: '13px', color: '#6b7280', lineHeight: '1.4' }}>{item.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
      <div><header className="static-header" style={{ position: 'sticky', top: 0, zIndex: 100, background: 'white', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
        <div className="container">
          <div className="header-content">
            <img src="/logo.png" alt="House Sharing Seniors" className="logo-image" onClick={() => navigate('/')} />
            <nav>
              <button className="btn btn-secondary" onClick={() => navigate('/properties')}>Browse Properties</button>
              <button className="btn btn-primary" onClick={() => navigate('/apply')}>Apply Now</button>
            </nav>
          </div>
        </div>
      </header>

      <section className="page-hero">
        <div className="container">
          <h1>HSS Features &amp; Functions</h1>
          <p>Everything the House Sharing Seniors platform does — for members, the public, and administrators.</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <Section title="Member Features (Logged-in Dashboard)" items={memberFeatures} color="#2563eb" />
          <Section title="Public Site Features (No Login Required)" items={publicFeatures} color="#059669" />
          <Section title="Admin Features (Admin Dashboard Only)" items={adminFeatures} color="#dc2626" />
        </div>
      </section>

      <footer className="static-footer">
        <div className="container">
          <p>&copy; 2026 House Sharing Seniors. All rights reserved.</p>
          <p className="footer-links">
            <a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of Service</a> | <a href="/contact">Contact Us</a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default FeaturesPage;
